export default "__VITE_ASSET__5ef2df48__"